import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const AnimatedText3D = () => {
  const sentences = [
    "Ziet u door het aanbod het overzicht niet meer?",
    "Dat is heel begrijpelijk.",
    "Er zijn veel aanbieders, allemaal met hun eigen verhaal.",
    "Wij brengen rust en duidelijkheid —",
    "en helpen u de juiste keuze maken."
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % sentences?.length);
    }, 3500); // Change sentence every 3.5 seconds

    return () => clearInterval(interval);
  }, [sentences?.length]);

  return (
    <div className="relative h-32 sm:h-40 lg:h-48 flex items-center justify-center perspective-1000">
      <AnimatePresence mode="wait">
        <motion.h2
          key={currentIndex}
          initial={{
            opacity: 0,
            scale: 0.8,
            rotateX: -45,
            rotateY: -15,
            z: -200,
            y: 50
          }}
          animate={{
            opacity: 1,
            scale: 1,
            rotateX: 0,
            rotateY: 0,
            z: 0,
            y: 0,
            transition: {
              duration: 0.8,
              ease: [0.25, 0.46, 0.45, 0.94],
              opacity: { duration: 0.5 },
              scale: { duration: 0.8 },
              rotateX: { duration: 0.8 },
              rotateY: { duration: 0.8 }
            }
          }}
          exit={{
            opacity: 0,
            scale: 0.8,
            rotateX: 45,
            rotateY: 15,
            z: -200,
            y: -50,
            transition: {
              duration: 0.6,
              ease: [0.55, 0.085, 0.68, 0.53]
            }
          }}
          className="text-2xl sm:text-3xl lg:text-4xl font-heading font-bold text-foreground absolute inset-0 flex items-center justify-center text-center px-4"
          style={{
            transformStyle: 'preserve-3d',
            textShadow: '0 4px 12px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.08)',
            backfaceVisibility: 'hidden'
          }}
        >
          <motion.span
            animate={{
              textShadow: [
                '0 4px 12px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.08)',
                '0 8px 24px rgba(59, 130, 246, 0.15), 0 4px 8px rgba(59, 130, 246, 0.1)',
                '0 4px 12px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.08)'
              ]
            }}
            transition={{
              duration: 2,
              repeat: Infinity,
              ease: 'easeInOut'
            }}
          >
            {sentences?.[currentIndex]}
          </motion.span>
        </motion.h2>
      </AnimatePresence>
      {/* Progress indicators */}
      <div className="absolute -bottom-16 left-1/2 transform -translate-x-1/2 flex gap-2">
        {sentences?.map((_, index) => (
          <motion.div
            key={index}
            className={`h-1.5 rounded-full transition-all duration-300 ${
              index === currentIndex ? 'w-8 bg-primary' : 'w-1.5 bg-muted-foreground/30'
            }`}
            animate={{
              scale: index === currentIndex ? [1, 1.2, 1] : 1
            }}
            transition={{
              duration: 0.5,
              repeat: index === currentIndex ? Infinity : 0,
              repeatDelay: 3
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default AnimatedText3D;